// ScaleTypeRadio.tsx
import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

interface ScaleTypeRadioProps {
  iconColor?: string;
  selectedOption: string;
  onOptionChange: (value: string) => void;
}

const typographyComponent = (value: string, iconColor?: string) => {
  return <Typography style={{ fontSize: '12px', color: iconColor }}>{value}</Typography>;
};

export const ScaleTypeRadio = ({
  selectedOption,
  onOptionChange,
  iconColor,
}: ScaleTypeRadioProps) => {
  return (
    <RadioGroup
      aria-labelledby="demo-controlled-radio-buttons-group"
      name="controlled-radio-buttons-group"
      value={selectedOption}
      onChange={(e) => onOptionChange(e.target.value)}
    >
      <FormControlLabel
        value="Automatic"
        sx={{ color: iconColor }}
        control={
          <Radio
            style={{
              color: selectedOption === 'Automatic' ? '#2bb9bb' : iconColor,
              marginBottom: '0px',
            }}
          />
        }
        label={typographyComponent('Automatic', iconColor)}
      />
      <FormControlLabel
        value="Manual"
        sx={{ transform: 'TranslateY(-9px)', color: iconColor }}
        control={
          <Radio
            style={{
              color: selectedOption === 'Manual' ? '#2bb9bb' : iconColor,
            }}
          />
        }
        label={typographyComponent('Manual', iconColor)}
      />
    </RadioGroup>
  );
};
